import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'tiktokEmbed' })
export class TiktokEmbedPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl | null {
    if (!url) {
      return null;
    }

    try {
      let videoId: string | null = null;

      const videoMatch = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
      if (videoMatch) {
        videoId = videoMatch[1];
      }

      if (!videoId) {
        const photoMatch = url.match(/tiktok\.com\/@[^/]+\/photo\/(\d+)/);
        if (photoMatch) {
          videoId = photoMatch[1];
        }
      }

      if (!videoId) {
        const numericMatch = url.match(/(\d{15,})/);
        if (numericMatch) {
          videoId = numericMatch[1];
        }
      }

      if (!videoId) {
        return null;
      }

      const embedUrl = `https://www.tiktok.com/player/v1/${videoId}?description=1&music_info=1&autoplay=1`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    } catch {
      return null;
    }
  }
}
